module.exports = __webpack_public_path__ + "img/037-bunting.e0617727.png";